import React from 'react';
import './DetailsBox.css';
import { DetailsBoxDivision } from '../../types/types';
import { Divider } from 'semantic-ui-react';


export interface DetailsBoxProps {
    divisions: DetailsBoxDivision[];
}
const DetailsBox: React.FC<DetailsBoxProps> = ({ divisions }) => {
    const widthPercentage = ((98-2*(divisions.length-1))/divisions.length) + "%";
    return (
        <div className="details-box">
            {divisions.map((division, index) => (
                <>
                    <div key={index} className="details-box-division" style={{width:widthPercentage}}>
                        {division.components.map((component, index) => (
                            <div key={index} className="details-box-component">
                                <span className="details-box-key">{component.label} : </span>
                                <span className="details-box-value">{component.value}</span>
                            </div>
                        ))}
                    </div>
                    {index != divisions.length - 1 &&
                        <Divider
                            style={{
                                borderRight: "2px dotted",
                                color: "#dfe2e7",
                                boxSizing: "border-box",
                                backgroundColor: "transparent"
                            }}
                            orientation="vertical"
                            flexItem
                        />
                    }
                </>
            ))}
        </div>
    );
};

export default DetailsBox;
